/**
 * presets.js — pure helpers for preset business logic.
 *
 * Extracted from BrainwaveGenerator.jsx (Phase 4 refactor). Anything in here
 * must be a pure function — no React, no API calls, no state mutations.
 */

/**
 * Decide whether a preset can be deleted/edited by the current user.
 *
 * Tags-based check first (legacy schema), then falls back to the modern
 * `is_builtin` + `category` fields. Built-ins / defaults are protected.
 */
export function canDeletePreset(preset) {
  if (!preset) return false;

  const userTags = ['custom', 'user-created'];
  const systemTags = ['built-in', 'default'];

  if (preset.tags && userTags.some((t) => preset.tags.includes(t))) return true;
  if (preset.tags && systemTags.some((t) => preset.tags.includes(t))) return false;

  if (preset.is_builtin === false && preset.category === 'user') return true;

  return !preset.is_builtin;
}

/**
 * Build the public share URL for a given share token.
 * Pure so it's easy to unit-test in JSDom without window mocking.
 */
export function buildShareUrl(shareId, origin = window.location.origin) {
  return `${origin}/app?shared=${shareId}`;
}
